<canvas #canvas
  baseChart
  [data]="chartData()"
  [options]="options()"
  [plugins]="plugins"
></canvas>
